import TranslationsConfigType from './translationType';

const nnTranslations: TranslationsConfigType = {
    tryAgain: 'Prøv igjen',
    showLess: 'Vis mindre',
    showMore: 'Vis meir',
    cancel: 'Avbryt',
    errors: {
        somethingWentWrong: 'Noko gjekk gale!',
        ohNo: 'Å nei!',
        oops: 'Oj sann!',
        timeoutMessage: 'Vi beklagar, det tok litt lenger tid enn me hadde tenkt. Du må gjerne prøva igjen',
        defaultMessage: 'Vi beklagar, det skjedde ein teknisk feil. Ver vennleg og prøv igjen litt seinare.',
        signing_done: 'Denne signeringsordren er allereie signert',
        signing_rejected: 'Denne signeringsordren er avvist',
        signrefnotfound: 'Denne signeringsordren er ikkje lenger tilgjengeleg for signering',
        generic_error: 'Noko gjekk gale',
    },
    documentsHeader: 'Oppgaver til gjennomgang',
    task: {
        documentsForSigning: 'Start signering av dokumenter',
        signedDocumentsForDownload: 'Signerte dokumenter til nedlasting',
        deadlinePassedTitle: 'Fristen har gått ut!',
        deadlinePassedMessage:
            'Denne søknaden har dessverre gått ut, fordi fristen for gjennomføring er ute. Ynskjer du fortsatt å søke, må du starte ein ny søknad.',
        cancelledTitle: 'Kansellert',
        cancelledMessage: 'Denne søknaden har vorte kansellert. Ynskjer du framleis å søkja må du starta ein ny søknad',
        rejectedTitle: 'Avvist',
        rejectedMessage: 'Denne søknaden har vorte avvist. Ynskjer du framleis å søkja må du starta ein ny søknad',
        tasksTitle: 'Oppgaver',
        attachmentsTitle: 'Vedlegg',
        documentsTitle: 'Dokumenter',
        signedTitle: 'Du har signert',
        signedMessage: 'Du har gjort ditt. Når alle partane er ferdig vil du finna ein nedlastbar versjon',
        readyForCancellationTitle: 'Klar for kansellering',
        readyForCancellationMessage:
            'Denne oppgåva er klar for kansellering. Ynskjer du framleis å søkja må du starte ein ny søknad',
    },
    taskStatus: {
        deadlinePassed: 'Fristen har gått ut',
        waitingForOtherSignees: 'Ventar på gjennomgangen til andre',
        requiresAction: 'Krev handling',
        rejected: 'Avvist',
        deadlineToday: 'Frist i dag',
        deadline: 'Frist {}',
        readyForCancellation: 'Klar for kansellering',
        signed: 'Signert: {} av {}',
        cancelled: 'Kansellert',
        consentAssignmentSigned: 'Signert',
    },
    recentlyReviewedHeader: 'Sist ferdigstilte oppgåver',
    noDocumentsForReview: 'Ingen oppgåver til gjennomgang',
    noNewlyReviewedTasks: 'Ingen nyleg ferdigstilte oppgåver',
    ok: 'Ok',
    consentAssignment: {
        title: 'Samtykkebasert lånesøknad',
        completedTitle: 'Takk for ditt samtykke',
        bodyText: {
            DEFAULT:
                `I samband med søknaden din om lån i {} er ` +
                `du oppført som {} med {}. ` +
                'For at de skal komma vidare i søknadsprosessen treng me ' +
                'ditt samtykke til å henta ut lønns- og skatteinformasjonen din frå Altinn.',
            KAUSJONIST:
                `{} har oppgitt deg som kausjonist i samband med søknad om lån i {}. ` +
                'For at me skal kunna behandla søknaden, treng me ditt samtykke til at ' +
                'me hentar ut din inntekts- og skatteinfomasjon frå Altinn.',
            HOVEDLAANTAKER:
                `I samband med søknaden din om lån i {} er ` +
                `du oppført som {}. ` +
                'For at de skal komma vidare i søknadsprosessen treng me ' +
                'ditt samtykke til å henta ut lønns- og skatteinformasjonen din frå Altinn.',
            ACCEPTED: 'Samtykket er motteke og lønns- og skatteinformasjonen din blir henta frå Skatteetaten.',
        },
        interestedParty: {
            HOVEDLAANTAKER: 'hovudlåntakar',
            MEDLAANTAKER: 'medlåntakar',
            KAUSJONIST: 'kausjonist',
            INNEHAVER: 'innehavar',
            DEFAULT: 'interessent',
        },
    },
    fundingCertificate: { title: 'Finansieringsbevis', description: 'Utlaupsdato: {}' },
    antiMoneyLaunderingTask: {
        title: 'Kundeerklæring antihvitvask',
        taskTitle: 'Svar på kundeerklæring',
        ahvTaskCompleted: {
            title: 'Kundeerklæring gjennomført!',
            description: 'Takk for at du har svart på kundeerklæringa.',
        },
        ahvTaskError: {
            title: 'Registering av kundeopplysningar feila!',
            description: 'Noko gjekk dessverre gale med registering av svara dine, ver vennleg og prøv om att seinare.',
        },
    },
    archive: {
        noArchivedTasks: 'Ingen gjennomgåtte oppgåver',
        title: 'Ferdige oppgåver',
        oldestFirst: 'Eldste først',
        newestFirst: 'Nyeste først',
    },
    sdoHelp: {
        howOpen: 'Korleis opnar eg den signerte fila (SDO)?',
        modalBody:
            'Ei SDO-fil er ikkje like lett å opna som ein vanleg PDF. Ønskjer du det, kan du bruka ei teneste frå Nets (BBS) som blir kalla E-signing Validator. Der kan du lasta opp fila og få stadfesta at ho er signert, i tillegg til å opna dokumentet. Følg lenkja nedanfor for å gå til Nets i eit nytt vindauge.',
        linkText: 'Åpne signerte dokument hos Nets',
    },
};

export default nnTranslations;
